import { render, staticRenderFns } from "./SuicidalCall.vue?vue&type=template&id=16feba77&scoped=true&"
import script from "./SuicidalCall.vue?vue&type=script&lang=ts&"
export * from "./SuicidalCall.vue?vue&type=script&lang=ts&"
import style0 from "./SuicidalCall.vue?vue&type=style&index=0&id=16feba77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16feba77",
  null
  
)

export default component.exports